// Signup identity requirements; preserve compatibility with legacy omitted types.
export default function validateSignupIdentity(values = {}) {
  const errors = {};
  const business = values.organizationType === "Business";
  const abn = typeof values.abnNumber === "string" ? values.abnNumber.trim() : "";
  const acn = typeof values.acnNumber === "string" ? values.acnNumber.trim() : "";
  if ((business || abn || (values.abnNumber != null && typeof values.abnNumber !== "string")) &&
      (!/^[\d -]+$/.test(abn) || abn.replace(/[ -]/g, "").length !== 11)) {
    errors.abnNumber = "Enter an 11-digit Australian Business Number.";
  }
  if (business && (!/^[\d -]+$/.test(acn) || acn.replace(/[ -]/g, "").length !== 9)) {
    errors.acnNumber = "Enter a 9-digit Australian Company Number.";
  }
  return errors;
}
